import {
  AccessDeniedError,
  BadRequestError,
  ConnectionError,
  HttpTypes,
  InternalServerError,
  TooManyRequestsError,
  UnexpectedError,
} from 'src/http';
import { httpResponseHandler } from 'src/http/http-response-handler';
import { BannerListTypeItem, fileUploadType } from 'src/types/banners';
import { endpoints } from 'src/utils/axios';
import { Either } from 'src/utils/either';

export class BannersRepository {
  constructor(private api: HttpTypes.HttpClient) {}

  async getBannersList(
    params?: any
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.banners.list,
      params,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async getBannerDetails(
    id: string
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'get',
      url: endpoints.banners.details(id),
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async updateBanner(
    updatedBanner: BannerListTypeItem[]
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.banners.update,
      body: updatedBanner,
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }

  async uploadFile(
    file: fileUploadType
  ): Promise<
    Either<
      | BadRequestError
      | UnexpectedError
      | InternalServerError
      | AccessDeniedError
      | ConnectionError
      | TooManyRequestsError,
      any | undefined
    >
  > {
    const request: HttpTypes.HttpRequest = {
      method: 'post',
      url: endpoints.files.upload,
      body: { ...file, optimizateImage: true },
    };

    const response = await this.api.request(request);

    return httpResponseHandler(response);
  }
}
